import { IErrorHandling } from '@Types/types.ts';

import { PhoneErrorMap, PhoneErrorsObjectMap } from './phone.errors';
import { SsnErrorMap, SSnErrorMapObject } from './ssn.errors';
import { EmailErrorMap, EmailErrorMapObject } from './email.errors';
import { GeneralErrorMap, GeneralErrorMapObject } from './general.errors';
import { PasswordErrorMap, PasswordErrorsObjectMap } from './password.errors';
import { AddressErrorMap, AddressErrorsObjectMap } from './address.errors';
import { AuthErrorMap, AuthErrorsObjectMap } from './auth.errors';
import { KycErrorMap, KycErrorsObjectMap } from './kyc.errors';
import { PersonalErrorMap, PersonalErrorsObjectMap } from './personal.errors';
import { BusinessErrorMap, BusinessErrorsObjectMap } from './business.errors';

const ErrorsMap = {
  ...AuthErrorMap,
  ...PhoneErrorMap,
  ...SsnErrorMap,
  ...EmailErrorMap,
  ...GeneralErrorMap,
  ...PasswordErrorMap,
  ...AddressErrorMap,
  ...KycErrorMap,
  ...PersonalErrorMap,
  ...BusinessErrorMap,
};

export const ErrorsMapList = Object.values(ErrorsMap);

export type ServerErrors = (typeof ErrorsMapList)[number];

export const CombinedErrorsObjectMap = new Map<number, IErrorHandling>([
  ...PhoneErrorsObjectMap,
  ...SSnErrorMapObject,
  ...EmailErrorMapObject,
  ...GeneralErrorMapObject,
  ...PasswordErrorsObjectMap,
  ...AddressErrorsObjectMap,
  ...AuthErrorsObjectMap,
  ...KycErrorsObjectMap,
  ...PersonalErrorsObjectMap,
  ...BusinessErrorsObjectMap,
]);
